import { inject, Injectable } from '@angular/core';
import { Observable }         from 'rxjs';
import { RestService }        from '../../core/rest.service';
import { environment }        from '../../../environments/environment';
import { AccountAccessData }  from './account-access';

@Injectable({
  providedIn: 'root'
})
export class AccountAccessService {
  private restService = inject(RestService);
  private apiEndpoint = environment.api.endpoints.accountMappings;

  getAccountsAccessData(): Observable<AccountAccessData[]> {
    return this.restService.get<AccountAccessData[]>(this.apiEndpoint);
  }

  revokeUserAccess(userEmail: string, username: string, accountIds: number[]): Observable<void> {
    return this.restService.delete<void>(this.apiEndpoint, {
      userEmail: userEmail,
      username: username,
      accountIds: accountIds
    });
  }
}
